@if (!isExplanationPanelOpen && itemCount && itemCount > 0) {
<div class="count-num">
  {{ 'common.label.question' | translate }}
  {{ currentItemPosition | number : '2.0-0' }} <span>/</span>
  {{ itemCount | number : '2.0-0' }}
</div>
}
<qa-mock-phone [class.isExplanationPanelOpen]="isExplanationPanelOpen">
  <div [class.shifted]="showExplanation" class="view-container">
    <div>
      <ng-scrollbar>
        <div
          [class.text-container-expanded]="isTextContainerExpanded"
          class="app-bar mat-elevation-z1"
        >
          <mat-icon>arrow_back</mat-icon>
          <div class="title">
            {{ 'questionMockPhone.courseName' | translate }}
          </div>
          <div class="right-buttons">
            <mat-icon>assessment</mat-icon>
            <mat-icon>more_vert</mat-icon>
          </div>
        </div>
        <div
          (click)="isTextContainerExpanded = !isTextContainerExpanded"
          class="text-container"
          matTooltipPosition="above"
        >
          <div class="quiz-title flex-row flex-align-items-center"></div>
          @if (question?.media?.uuid) {
          <img
            src="{{ 'mediaUrl' | env }}/{{ question.media.uuid }}.{{
              question.media.file_ext
            }}"
          />
          }
          <div class="question-text">
            <qa-markdown-katex [data]="question.text"> </qa-markdown-katex>
          </div>
        </div>
        <div class="hint">
          @if (question.type === questionTypeEnum.TRUE_FALSE) {
          {{ 'question.hint.chooseStatement' | translate }}
          } @if ( !isPollQuestion && question.type ===
          questionTypeEnum.MULTIPLE_CHOICE ) {
          {{ 'question.hint.chooseAll' | translate }}
          } @if ( !isPollQuestion && question.type ===
          questionTypeEnum.SINGLE_CHOICE ) {
          {{ 'question.hint.selectRightAnswer' | translate }}
          } @if ( isPollQuestion && question.type ===
          questionTypeEnum.MULTIPLE_CHOICE ) {
          {{ 'question.hint.selectYourAnswers' | translate }}
          } @if ( isPollQuestion && question.type ===
          questionTypeEnum.SINGLE_CHOICE ) {
          {{ 'question.hint.selectYourAnswer' | translate }}
          } @if (question.type === questionTypeEnum.FREETEXT) { @if (
          isPollQuestion && question?.max_answer_submissions > 1) {
          {{ 'question.hint.typeYourAnswers' | translate }}
          } @else {
          {{ 'question.hint.typeYourAnswer' | translate }}
          } }
        </div>
        <div class="separator"></div>
        <div class="answer-container" [class.isPollAnswer]="isPollQuestion">
          <div
            class="scroll-container"
            [class.trueFalse]="question.type === questionTypeEnum.TRUE_FALSE"
          >
            <ng-template #answerContainer let-answer="answer">
              <div class="answer flex-row flex-align-items-center">
                <div
                  class="radio-checkbox"
                  [style.borderColor]="isPollQuestion ? brandingColor : null"
                  [class.multi]="
                    question.type === questionTypeEnum.MULTIPLE_CHOICE
                  "
                >
                  @if (question.type === questionTypeEnum.MULTIPLE_CHOICE) {
                  <mat-checkbox
                    [disabled]="isPollQuestion"
                    color="primary"
                    [checked]="answer.is_right && !isPollQuestion"
                  ></mat-checkbox>
                  } @if (question.type !== questionTypeEnum.MULTIPLE_CHOICE) {
                  <div class="radio-button">
                    @if (answer.is_right && !isPollQuestion) {
                    <mat-icon class="correct">radio_button_checked</mat-icon>
                    } @if (!answer.is_right || isPollQuestion) {
                    <mat-icon class="in-correct"
                      >radio_button_unchecked</mat-icon
                    >
                    }
                  </div>
                  }
                </div>
                <div
                  class="text flex-grow"
                  [style.backgroundColor]="
                    isPollQuestion ? brandingColor : null
                  "
                >
                  <qa-markdown-katex [data]="answer.text"> </qa-markdown-katex>
                </div>
              </div>
            </ng-template>
            @if (question.type === questionTypeEnum.TRUE_FALSE) {
            <ng-container
              *ngTemplateOutlet="
                answerContainer;
                context: { answer: trueFalseAnswerTrue }
              "
            >
            </ng-container>
            <ng-container
              *ngTemplateOutlet="
                answerContainer;
                context: { answer: trueFalseAnswerFalse }
              "
            >
            </ng-container>
            } @if ( question.type !== questionTypeEnum.TRUE_FALSE &&
            question.type === questionTypeEnum.FREETEXT) { @if (isPollQuestion)
            { @for (answer of maxAnswerSubmissions; track $index) {
            <div
              class="answer flex-row flex-align-items-center correct freetext"
            >
              <div class="text flex-grow">
                {{ 'question.label.enterAnswer' | translate }}
              </div>
              <div class="max-character">
                0 / {{ question.max_num_characters || 0 }}
              </div>
            </div>
            } } @else {
            <div
              class="answer flex-row flex-align-items-center correct freetext"
            >
              <div class="text flex-grow">
                {{ 'question.label.enterAnswer' | translate }}
              </div>
              <div class="max-character">
                0 / {{ question.max_num_characters || 0 }}
              </div>
            </div>
            } } @else { @for (answer of question.answers; track $index) {
            <ng-container
              *ngTemplateOutlet="answerContainer; context: { answer: answer }"
            >
            </ng-container>
            } }
          </div>
        </div>
      </ng-scrollbar>
      @if (!isExplanationPanelOpen) {
      <div
        @flyInOutHorizontal
        (click)="openExplainPanel($event, true)"
        class="check-button"
        [class.isPollQuestion]="isPollQuestion"
      >
        {{ 'question.form.explanation' | translate }}
        <mat-icon>arrow_back_ios</mat-icon>
      </div>
      }
      <div
        class="explanation-panel qa-theme-inverted"
        [ngClass]="{
          isPanelOpen: isExplanationPanelOpen,
          isPollQuestion: isPollQuestion
        }"
      >
        @if (isExplanationPanelOpen) {
        <div class="wrapper-exp">
          <div class="exapantion-title">
            {{ 'question.form.explanation' | translate }}
          </div>
          <button
            (click)="openExplainPanel($event, true)"
            class="toggle-explanation-button"
            color="primary"
            mat-button
            type="button"
          >
            <mat-icon>arrow_back_ios</mat-icon>
          </button>
          <ng-scrollbar class="scroll-container">
            @if (question.explanation) {
            <qa-markdown-katex [data]="question.explanation">
            </qa-markdown-katex>
            } @else {
            <div class="placeholder">
              {{ 'questionMockPhone.noExplanation' | translate }}
            </div>
            }
          </ng-scrollbar>
        </div>
        }
        <div class="actions">
          @if (getWeblink()) {
          <a
            [href]="getWeblink()"
            color="primary"
            mat-button
            target="_blank"
            type="button"
          >
            <mat-icon>open_in_new</mat-icon>
            {{ 'question.openWebLink' | translate }}
          </a>
          }
        </div>
      </div>
    </div>
    <div>
      <div class="app-bar">
        <mat-icon
          (click)="isWeblinkTabActive = false; showExplanation = false"
          matTooltip="{{
            'questionMockPhone.tooltip.backToQuestion' | translate
          }}"
          class="back-to-question-button"
          matTooltipPosition="right"
        >
          arrow_back
        </mat-icon>
        <div class="title">
          {{ 'questionMockPhone.explanation' | translate }}
        </div>
      </div>
      <div class="tabs-container">
        <div class="tabs">
          <div (click)="isWeblinkTabActive = false" matRipple>
            {{ 'questionMockPhone.explanation' | translate }}
          </div>
          <div (click)="isWeblinkTabActive = true" matRipple>Weblink</div>
        </div>
        <div [class.shifted]="isWeblinkTabActive" class="ink-bar"></div>
      </div>
      <div [class.shifted]="isWeblinkTabActive" class="tab-content-container">
        <div class="explanation-tab-content">
          @if (question.explanation) {
          <qa-markdown-katex [data]="question.explanation"> </qa-markdown-katex>
          } @else {
          <div class="placeholder">
            {{ 'questionMockPhone.noExplanation' | translate }}
          </div>
          }
        </div>
        <div class="weblink-tab-content">
          <div>
            {{ 'questionMockPhone.weblinkText' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</qa-mock-phone>
